<template lang="pug">
  component(
    :is="currentView"
    :products="products")
</template>

<script>
import productsConfig from "@/config/product";
import Product from "@/views/product";

export default {
  data() {
    return {
      products: productsConfig,
      currentView: this.$route.params.PName
    };
  },
  components: {
    KettleBell: Product,
    "KettleBell-Advanced": Product,
    "Multi-Weight": Product,
    AirMate: Product,
    ChildSeat: Product,
    Corechair: Product,
    DEX: Product,
    XEZhead: Product,
    BikeRepairStand: Product,
    DogYearGift: Product,
    Ratchet: Product,
    PixoTest: Product,
    SafePlay: Product,
    eSPORT: Product,
    Bonzai: Product,
    "DAB-Stereo": Product,
    "CFL-228": Product,
    FlipGaugePump: Product,
    DuracellHDD: Product,
    WindLionGod: Product,
    Rii: Product,
    EZmug: Product,
    TonTon: Product,
    RooCare: Product,
    Worthon: Product
  },
  watch: {
    $route() {
      this.currentView = this.$route.params.PName;
    }
  }
};
</script>
